import { graphql, useStaticQuery } from "gatsby";
import { PathQuery } from "../types";

const useVideoURL = (name?: string) => {
  const {
    allFile: { edges },
  }: PathQuery = useStaticQuery(graphql`
    query {
      allFile(filter: { sourceInstanceName: { eq: "videos" } }) {
        edges {
          node {
            name
            publicURL
          }
        }
      }
    }
  `);

  const node = edges.find((edge) => edge.node.name === name)?.node;
  if (!node) return null;
  return node.publicURL;
};

export default useVideoURL;
